import { toastError } from 'admination-react'
import { useCallback, useEffect, useRef } from 'react'
import type { VertragView } from '@/core/data/portalViews'
import { PdfRegion, ZOOMED_OUT_PDF_SCALE } from '@/core/components/modal/PdfRegion'
import { useListActionsSink } from '@/core/components/list/listActions'
import { downloadFile } from '@/core/data/storage'
import { downloadBlob } from '@/core/lib/files'

export function VertragTab({ vertrag, onSign }: { vertrag: VertragView; onSign: () => void }) {
  const signed = vertrag.participantSigned
  const pdfPath = vertrag.pdfPath ?? null

  const onSignRef = useRef(onSign)
  useEffect(() => {
    onSignRef.current = onSign
  })

  const handleDownload = useCallback(async () => {
    if (!pdfPath) {
      toastError('Vertrag konnte nicht geladen werden.')
      return
    }
    const blob = await downloadFile(pdfPath)
    if (!blob) {
      toastError('Vertrag konnte nicht geladen werden.')
      return
    }
    downloadBlob(blob, 'Vertrag.pdf')
  }, [pdfPath])

  const sink = useListActionsSink()
  useEffect(() => {
    if (!sink) return
    if (signed) {
      sink({
        actions: [
          { id: 'download', label: 'Herunterladen', icon: 'i-download', primary: true, iconOnly: true },
        ],
        onRun: (id) => {
          if (id === 'download') void handleDownload()
        },
      })
      return () => sink(null)
    }
    sink({
      actions: [{ id: 'sign', label: 'Unterschreiben', icon: 'i-signature', primary: true }],
      onRun: (id) => {
        if (id === 'sign') onSignRef.current()
      },
    })
    return () => sink(null)
  }, [sink, signed, handleDownload])

  return <PdfRegion
      path={pdfPath}
      loadingLabel="Vertrag wird geladen …"
      placeholder="Vertrag wird geladen…"
      scaleFactor={ZOOMED_OUT_PDF_SCALE}
    />
}
